import nameModelValidator from 'forms/shared/validators/models/name/name';
import { hasYesOrNo } from 'models/validate';
import { isPVQForm } from 'helpers/form';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSValidatorOption } from 'forms/shared/types';
import pvqNameModelValidator from '../pvqName/name';

// This should go to citizenshipMultiple. Waiting on https://gitlab.devops.nbis.mil/gitlab/eapp/eapp-web-app/merge_requests/721/
const alias: ValidateJSValidatorOption = {
  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options.formType)) {
      return {
        presence: true,
        model: { validator: pvqNameModelValidator },
      };
    }

    return {
      presence: true,
      model: { validator: nameModelValidator },
    };
  },

  NameOptions: (value, attributes, attributeName, options) => {
    if (isPVQForm(options.formType)) {
      return {
        presence: true,
        hasValue: true,
      };
    }

    return {};
  },

  NameOptionsExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options.formType) && attributes.NameOptions?.value === 'Other') {
      return {
        presence: true,
        hasValue: true,
      };
    }

    return {};
  },

  MaidenName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options.formType)) {
      return {};
    }
    return {
      presence: true,
      hasValue: { validator: hasYesOrNo },
    };
  },
  Dates: (value, attributes, attributeName, options) => {
    const dateLimits = { earliest: DEFAULT_EARLIEST, latest: DEFAULT_LATEST };
    if (options.earliest) { dateLimits.earliest = options.earliest; }

    return {
      presence: true,
      daterange: dateLimits,
    };
  },
  Reason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options.formType)) {
      return {};
    }
    return {
      presence: true,
      hasValue: true,
    };
  },
};

export default alias;
